// @flow

// Modules
import React from 'react';
import styled from 'styled-components';
import { map } from 'lodash';

import { BLUE_GREY, COOL_GREY, BLACK, getGameTypeColorBackground } from 'src/styles/palettes.js';

// Components

/**
 * Styles
 */

const OptionsBarRoot = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: ${BLUE_GREY[700]};
  margin-bottom: 1.2em;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  padding: 0.4em 0.5em;
  justify-content: center;
  background-color: ${(props) => (props.isSelected ? props.color : BLUE_GREY[700])};
  border-radius: 6px;
  color: ${(props) => (props.isSelected ? BLACK : COOL_GREY[200])};
  text-align: center;
  font-weight: 800;
  cursor: pointer;
`;

/**
 * Types
 */

type PropTypes = {
  options: Object,
  selectedOptions: number,
  onItemClick: (newMode: number) => void
};

/*
 ** Component
 */

const OptionsBar = (props: PropTypes): React$Element<any> => {
  const { options, selectedOptions, onItemClick } = props;

  return (
    <OptionsBarRoot>
      {map(options, (option, key: number) => (
        <Option
          key={`bar-option-${key}`}
          color={getGameTypeColorBackground(option.id)}
          isSelected={selectedOptions === key}
          onClick={() => onItemClick(key)}>
          {option.name}
        </Option>
      ))}
    </OptionsBarRoot>
  );
};

export default OptionsBar;
